import React from "react";
import { useI18n } from "@/context/I18nContext";
import { Button } from "@/components/ui/button";
import { ChevronLeft, ChevronRight } from "lucide-react";

export function TablePagination({ page, pages, total, onPage }) {
  const { t } = useI18n();
  if (!total) return null;
  return (
    <div className="flex items-center justify-between border-t px-2 py-3 text-sm">
      <span className="text-muted-foreground">
        {t("common.page")} {page} {t("common.of")} {pages || 1} · {total} {t("common.records")}
      </span>
      <div className="flex gap-2">
        <Button
          variant="outline"
          size="sm"
          disabled={page <= 1}
          onClick={() => onPage(page - 1)}
          data-testid="pagination-prev"
        >
          <ChevronLeft className="h-4 w-4" /> {t("common.prev")}
        </Button>
        <Button
          variant="outline"
          size="sm"
          disabled={page >= (pages || 1)}
          onClick={() => onPage(page + 1)}
          data-testid="pagination-next"
        >
          {t("common.next")} <ChevronRight className="h-4 w-4" />
        </Button>
      </div>
    </div>
  );
}
